import { TimelineItemWebComponent } from './component/TimelineItemWebComponent';
import { WEB_COMPONENT_TIMELINE_ITEM } from '../../webcomponents.constants';

export { TimelineItemWebComponent };

window.customElements.define(WEB_COMPONENT_TIMELINE_ITEM, TimelineItemWebComponent);
